//项目域名
const postUrl = 'http://testdmssunmiapi.51autoshop.com/api/';//测试接口地址

// const postUrl = 'http://dmssunmiapi.51autoshop.com/api/'; //正式接口地址

export default {
  postUrl,
}


//////////////////
// WEBPACK FOOTER
// ./static/js/basedata.js
// module id = null
// module chunks = 